import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalCloseAll } from "../../modals/actionModal";
import { actionBuildingsSkipConstruction } from "../../player-base/buildings/actionBuildings";
import { TypeActionQuickSkip } from "../actionQuickSkip";
export var epicQuickSkipConstructionSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuickSkip.SkipConstruction), switchMap(function (action) {
        return from([
            actionModalCloseAll(),
            actionBuildingsSkipConstruction(action.building, action.action),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/epics/epicQuickSkipConstructionSkip.ts
// module id = 2114
// module chunks = 3